<app-indices-docs-page [indexType]="'trs'"></app-indices-docs-page>
